// eslint-disable-next-line import/prefer-default-export
export const FeatureId = {
  RISK_TOL_QUEST: 1,
  BANK_TRANSFER: 2,
  OPEN_ACCOUNT: 3,
  ADD_EDIT_DELETE_GOAL: 4,
  RISK_TOL_OVERRIDE: 7,
  FEE_SCHEDULE: 8,
  PERFORMANCE_REPORTING: 9,
  WEALTH_PROJECTION_GOAL: 10,
  WEALTH_PROJECTION_ACCOUNT: 11,
  INDIVIDUAL: 12,
  TRADITIONAL_IRA: 13,
  ROTH_IRA: 14,
  TOTAL_CASH_VALUE_BOX: 15,
  TOTAL_ACCOUNTS_CASH_BOX: 16,
  TOTAL_GOALS_CASH_BOX: 17,
  ATTACH_ACCOUNT: 24,
  CURRENT_PORTFOLIO_ACCOUNT: 25,
  TARGET_PORTFOLIO_ACCOUNT: 26,
  CURRENT_PORTFOLIO_GOAL: 27,
  TARGET_PORTFOLIO_GOAL: 28,
  SEP_IRA: 29,
  SIMPLE_IRA: 30,
  ACCOUNT_AGGREGATION: 31,
  FULL_LIQUIDATION: 32,
  BANK_LINK_IDENTITY_VERIFICATION: 33,
  BALANCE_CHECK: 34,
  CONTACT_US: 35,
  ACCOUNT_MINIMUM_AMOUNT: 36,
  BCC_LIQUIDATION_EMAILS: 37,
  CLIENT_MINIMUM_AMOUNT: 38,
};
